import { Box, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { IconButton } from "../../../../shared";

/**
 * Info cell renderer - navigates to edit supplier page
 */
export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    const handleClick = () => {
        navigate(`/suppliers/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="View details" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                    }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

/**
 * Status chip component with color coding
 */
export function StatusChip({ status }: { status: string }) {
    const getStatusConfig = (status: string) => {
        const upperStatus = status?.toUpperCase() || "";
        switch (upperStatus) {
            case "ACTIVE":
                return { color: "success" as const, label: "Active" };
            case "INACTIVE":
                return { color: "neutral" as const, label: "Inactive" };
            default:
                return { color: "neutral" as const, label: status || "Unknown" };
        }
    };

    const config = getStatusConfig(status);
    return (
        <Chip
            variant="soft"
            color={config.color}
            size="md"
            sx={{ borderRadius: "4px", border: "1px solid", borderColor: "divider" }}
        >
            {config.label}
        </Chip>
    );
}

/**
 * Status cell renderer
 */
export function StatusCellRenderer(props: any) {
    const { value } = props;
    return <StatusChip status={value} />;
}
